import React, {Component} from 'react';
import NewsletterSignupForm from './NewsletterSignupForm'
import AppLink from './AppLink'

export default class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            invalidEmailForm: false,
            signUpSuccess: false
        }
    }

    onSignupEmailSuccess = () => {
        this.setState({signUpSuccess: true});
    };

    onInvalidEmailForm = () => {
        this.setState({invalidEmailForm: true});
    }

    onValidEmailForm = () => {
        this.setState({invalidEmailForm: false});
    }

    render() {
        return (
            <div className="footer">
                <div className="top">
                    <div className="container">
                        <div className="row">
                            <div className="left col-12 col-md-6 col-lg-6">
                                <h3>Les mer om Fristberegneren</h3>
                                <p><AppLink to='/about'>Om Fristberegneren</AppLink></p>
                                <p><AppLink to='/terms'>Vilkår og betingelser</AppLink></p>
                            </div>
                            <div className="right col-12 col-md-6 col-lg-6">
                                <h3>Påmelding til nyhetsbrev</h3>
                                <p>Bli oppdatert på våre siste nyheter om anskaffelser og få informasjon om våre aktiviteter og invitasjoner til faglige arrangementer. Vi bruker kun dine opplysninger til utsendelse av nyhetsbrevet, og sletter de dersom du melder deg av eller vi slutter med å sende ut nyheter. Les mer om hvordan vi behandler dine opplysninger her.</p>
                                <NewsletterSignupForm onSignUpSuccess={this.onSignupEmailSuccess}
                                                      onValidForm={this.onValidEmailForm}
                                                      onInvalidForm={this.onInvalidEmailForm}/>
                                {this.state.invalidEmailForm &&
                                <div className="error">Det oppsto en feil i e-posten din.</div>
                                }
                                {this.state.signUpSuccess &&
                                <div className="success"><strong>Takk for at du registrerte deg.</strong></div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="container">
                        <p>Fristberegneren tilbys av:</p>
                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <h4>Kvale Advokatfirma DA</h4>
                                        <p><a href="http://www.kvale.no"
                                              target="_blank">www.kvale.no</a></p>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <h4>Oslo</h4>
                                        <p>Haakon VIIs gate 10</p>
                                        <p>0161 Oslo</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="row">
                                    <div className="col-12 col-lg-6">
                                        <p>Telefon <a href="tel:+4722479700">+47 22 47 97 00</a></p>
                                        <p><a href="mailto:fristberegneren@kvale.no">fristberegneren@kvale.no</a></p>
                                        <p>NO 947 996 053 MVA</p>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js